import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AssignMeterService } from '../../service/assignmeter.service';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';


@Component({
  selector: 'app-flowmeter-list',
  templateUrl: './flowmeter-list.component.html'
})



export class FlowmeterListComponent implements OnInit {

  errorMsg: string = '';
  successMsg: string = '';
  EnergyMeterForm: FormGroup;
  UserId: number = 0;
  CompanyId: number = 0;
  SiteEnergyMeterList: [];
  windowheight: any;
  divHeight: number;
  tableHeight: number;

  // Called when window resize
  onResize() {
    this.ResizeHeight();
  }

  // Called function on initial and window resize
  ResizeHeight() {
    this.windowheight = localStorage.getItem('WindowHeight');
    this.divHeight = this.windowheight - 100;
    this.tableHeight = this.divHeight - 140;
  }

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<FlowmeterListComponent>, private form: FormBuilder, private assignmeterservice: AssignMeterService) {
    dialogRef.disableClose = true;
    if (data && data.UserId) {
      this.UserId = data.UserId;
    }
    if (data && data.CompanyId) {
      this.CompanyId = data.CompanyId;
    }
  }

  ngOnInit(): void {

    this.ResizeHeight();

    this.EnergyMeterForm = this.form.group({
      'SiteArray': this.form.array([
      ])
    });

    this.GetSiteEnergyMeterList();

  }

  // Panel Array
  PanelArray(lstpanel) {
    return this.form.group({
      SitePanelId: lstpanel.SitePanelId,
      PanelName: lstpanel.PanelName,
      IsAssigned: false,
      'DeviceArray': this.form.array([
      ])
    });
  }

  // Device Array
  DeviceArray(lstdevice) {
    return this.form.group({
      DeviceTypeID: lstdevice.DeviceTypeID,
      DeviceName: lstdevice.DeviceName,
      IsAssigned: false,
      'EnergyMeterArray': this.form.array([
      ])
    });
  }

  // Energy Meter Array
  EnergyMeterArray(lstenergy) {
    return this.form.group({
      EnergymeterID: lstenergy.EnergymeterID,
      EnergymeterMasterID: lstenergy.EnergymeterMasterID,
      IsAssigned: lstenergy.IsAssigned
    });
  }

  // Get Site Energy Meter list User wise
  GetSiteEnergyMeterList() {

    this.assignmeterservice.GetSiteEnergyMeterList(this.CompanyId, this.UserId).subscribe(
      (result) => {
        this.Assignlistintable(result.ListCompSiteMasterBO);

      },
      (error) => {
        this.SiteEnergyMeterList = error;
      }
    );
  }

  // Assign List in Table
  Assignlistintable(lstlist) {
    if (lstlist && lstlist != null && lstlist.length > 0) {
      this.SiteEnergyMeterList = lstlist;
      this.SiteEnergyMeterList.forEach((element, i) => {
        this.AddListRow(this.SiteEnergyMeterList[i], i);
      });
    }
  }

  // Add List Row
  AddListRow(Row, index) {
    var IsAssigned = false;
    const ArrSite = <FormArray>this.EnergyMeterForm.controls['SiteArray'];
    ArrSite.push(this.form.group({
      CompSiteName: Row && Row.CompSiteName ? Row.CompSiteName : '',
      IsAssigned: IsAssigned,
      IsShowChild: false,
      'PanelArray': this.form.array([
      ])

    }));

    // Start Panel Array
    var lstpanelLength = Row.ListPanelMasterBO.length;
    var panellength = 0;

    const PanelArray = (<FormArray>this.EnergyMeterForm.controls['SiteArray']).at(index).get('PanelArray') as FormArray;
    Row.ListPanelMasterBO.forEach((element, i) => {
      PanelArray.push(
        this.PanelArray(element)
      );

      // End panel Array

      // Start Device Array

      var lstdeviceLength = Row.ListPanelMasterBO[i].ListDevicetypeMasterBO.length;
      var devicelength = 0;

      const DeviceArray = ((<FormArray>this.EnergyMeterForm.controls['SiteArray']).at(index).get('PanelArray') as FormArray).at(i).get('DeviceArray') as FormArray;

      Row.ListPanelMasterBO[i].ListDevicetypeMasterBO.forEach((element, j) => {
        DeviceArray.push(
          this.DeviceArray(element)
        );

        // End Device Array

        // Start EnergyMeter Array
        var lstEnergyLength = Row.ListPanelMasterBO[i].ListDevicetypeMasterBO[j].ListEnergymeterMasterBO.length;
        var length = 0;
        const ArrEnergy = (((<FormArray>this.EnergyMeterForm.controls['SiteArray']).at(index).get('PanelArray') as FormArray).at(i).get('DeviceArray') as FormArray).at(j).get('EnergyMeterArray') as FormArray;
        Row.ListPanelMasterBO[i].ListDevicetypeMasterBO[j].ListEnergymeterMasterBO.forEach((element, k) => {
          if (element.IsAssigned == true) {
            length++;
          }
          ArrEnergy.push(
            this.EnergyMeterArray(element)
          );
        });

        if (lstEnergyLength == length && lstEnergyLength > 0) {
          panellength++;
          devicelength++;
          ((this.EnergyMeterForm.get('SiteArray') as FormArray).at(index).get('PanelArray') as FormArray).at(i).get('IsAssigned').patchValue(true);
          (((this.EnergyMeterForm.get('SiteArray') as FormArray).at(index).get('PanelArray') as FormArray).at(i).get('DeviceArray') as FormArray).at(j).get('IsAssigned').patchValue(true);
        }
        else {
          ((this.EnergyMeterForm.get('SiteArray') as FormArray).at(index).get('PanelArray') as FormArray).at(i).get('IsAssigned').patchValue(false);
          (((this.EnergyMeterForm.get('SiteArray') as FormArray).at(index).get('PanelArray') as FormArray).at(i).get('DeviceArray') as FormArray).at(j).get('IsAssigned').patchValue(false);
        }
        // End EnergyMeter Array
      });
    });


    if (lstpanelLength == panellength) {
      (this.EnergyMeterForm.get('SiteArray') as FormArray).at(index).get('IsAssigned').patchValue(true);
    }
    else {
      (this.EnergyMeterForm.get('SiteArray') as FormArray).at(index).get('IsAssigned').patchValue(false);
    }
  }

  // Called on Select All checkbox
  SelectAll(checked, index) {

    const ArrPanel = (<FormArray>this.EnergyMeterForm.controls['SiteArray']).at(index).get('PanelArray') as FormArray;

    ArrPanel.value.forEach((element, i) => {
      const PanelValues = ((this.EnergyMeterForm.get('SiteArray') as FormArray).at(index).get('PanelArray') as FormArray).at(i);
      PanelValues.get('IsAssigned').patchValue(checked == true ? true : false);


      const ArrDevice = ((<FormArray>this.EnergyMeterForm.controls['SiteArray']).at(index).get('PanelArray') as FormArray).at(i).get('DeviceArray') as FormArray;

      ArrDevice.value.forEach((element, j) => {
        const DeviceValues = (((this.EnergyMeterForm.get('SiteArray') as FormArray).at(index).get('PanelArray') as FormArray).at(i).get('DeviceArray') as FormArray).at(j);
        PanelValues.get('IsAssigned').patchValue(checked == true ? true : false);
        DeviceValues.get('IsAssigned').patchValue(checked == true ? true : false);

        const ArrEnergy = (((<FormArray>this.EnergyMeterForm.controls['SiteArray']).at(index).get('PanelArray') as FormArray).at(i).get('DeviceArray') as FormArray).at(j).get('EnergyMeterArray') as FormArray;

        ArrEnergy.value.forEach((element, k) => {
          const EMValues = ((((this.EnergyMeterForm.get('SiteArray') as FormArray).at(index).get('PanelArray') as FormArray).at(i).get('DeviceArray') as FormArray).at(j).get('EnergyMeterArray') as FormArray).at(k);
          DeviceValues.get('IsAssigned').patchValue(checked == true ? true : false);
          EMValues.get('IsAssigned').patchValue(checked == true ? true : false);
        });
      });
    });
  }

  SelectPanel(checked, siteIndex, panelIndex) {

    const Arrdevice = ((<FormArray>this.EnergyMeterForm.controls['SiteArray']).at(siteIndex).get('PanelArray') as FormArray).at(panelIndex).get('DeviceArray') as FormArray;

    Arrdevice.value.forEach((element, j) => {
      const EMValues = (((this.EnergyMeterForm.get('SiteArray') as FormArray).at(siteIndex).get('PanelArray') as FormArray).at(panelIndex).get('DeviceArray') as FormArray).at(j);
      EMValues.get('IsAssigned').patchValue(checked == true ? true : false);

      const ArrEnergy = (((<FormArray>this.EnergyMeterForm.controls['SiteArray']).at(siteIndex).get('PanelArray') as FormArray).at(panelIndex).get('DeviceArray') as FormArray).at(j).get('EnergyMeterArray') as FormArray;

      ArrEnergy.value.forEach((element, k) => {
        const EMValues = ((((this.EnergyMeterForm.get('SiteArray') as FormArray).at(siteIndex).get('PanelArray') as FormArray).at(panelIndex).get('DeviceArray') as FormArray).at(j).get('EnergyMeterArray') as FormArray).at(k);
        EMValues.get('IsAssigned').patchValue(checked == true ? true : false);
      });


    });


  }

  SelectDevice(lstpanel, checked, siteIndex, panelIndex, deviceIndex) {
    var length = 0;
    lstpanel.value.DeviceArray.forEach((element, i) => {
      if (element.IsAssigned == true) {
        length++;
      }
    });

    if (lstpanel.value.DeviceArray.length == length) {
      ((this.EnergyMeterForm.get('SiteArray') as FormArray).at(siteIndex).get('PanelArray') as FormArray).at(panelIndex).get('IsAssigned').patchValue(true);
    }
    else {
      ((this.EnergyMeterForm.get('SiteArray') as FormArray).at(siteIndex).get('PanelArray') as FormArray).at(panelIndex).get('IsAssigned').patchValue(false);
    }

    const ArrEnergy = (((<FormArray>this.EnergyMeterForm.controls['SiteArray']).at(siteIndex).get('PanelArray') as FormArray).at(panelIndex).get('DeviceArray') as FormArray).at(deviceIndex).get('EnergyMeterArray') as FormArray;

    ArrEnergy.value.forEach((element, j) => {
      const EMValues = ((((this.EnergyMeterForm.get('SiteArray') as FormArray).at(siteIndex).get('PanelArray') as FormArray).at(panelIndex).get('DeviceArray') as FormArray).at(deviceIndex).get('EnergyMeterArray') as FormArray).at(j);
      EMValues.get('IsAssigned').patchValue(checked == true ? true : false);
    });
  }

  SelectEnergy(lstdevice, siteIndex, panelIndex, deviceIndex) {
    var length = 0;
    lstdevice.value.EnergyMeterArray.forEach((element, i) => {
      if (element.IsAssigned == true) {
        length++;
      }
    });

    if (lstdevice.value.EnergyMeterArray.length == length) {
      ((this.EnergyMeterForm.get('SiteArray') as FormArray).at(siteIndex).get('PanelArray') as FormArray).at(panelIndex).get('IsAssigned').patchValue(true);
      (((this.EnergyMeterForm.get('SiteArray') as FormArray).at(siteIndex).get('PanelArray') as FormArray).at(panelIndex).get('DeviceArray') as FormArray).at(deviceIndex).get('IsAssigned').patchValue(true);
    }
    else {
      ((this.EnergyMeterForm.get('SiteArray') as FormArray).at(siteIndex).get('PanelArray') as FormArray).at(panelIndex).get('IsAssigned').patchValue(false);
      (((this.EnergyMeterForm.get('SiteArray') as FormArray).at(siteIndex).get('PanelArray') as FormArray).at(panelIndex).get('DeviceArray') as FormArray).at(deviceIndex).get('IsAssigned').patchValue(false);
    }
  }

  // Called on Save button click
  OnSave() {
    this.successMsg = '';
    this.errorMsg = '';
    var EnergyMasterIds = '';
    var SiteArray = <FormArray>this.EnergyMeterForm.controls['SiteArray'];

    SiteArray.value.forEach((element, i) => {
      element.PanelArray.forEach((element, j) => {
        element.DeviceArray.forEach((element, k) => {
          element.EnergyMeterArray.forEach((element, l) => {
            if (element.IsAssigned == true) {
              EnergyMasterIds = EnergyMasterIds + element.EnergymeterMasterID + ',';
            }
          });
        });
      });
    });


    EnergyMasterIds = EnergyMasterIds.replace(/,(?=[^,]*$)/, '');
    this.assignmeterservice.AssignEnergymeter(this.CompanyId, this.UserId, EnergyMasterIds).subscribe(
      (result) => {
        if (result) {
          this.successMsg = 'Values submitted successfully';
        }
      },
      (error) => {
        this.errorMsg = error;
      }
    );
  }

  // called on close icon
  Close() {
    this.dialogRef.close();
  }

  // Show Energy meter
  ShowChild(ShowChild, index) {

    if (ShowChild == 'Y') {
      (this.EnergyMeterForm.get('SiteArray') as FormArray).at(index).get('IsShowChild').patchValue(true);
    }
    else {
      (this.EnergyMeterForm.get('SiteArray') as FormArray).at(index).get('IsShowChild').patchValue(false);
    }
  }

  // called on cancel button
  OnCancel() {
    this.dialogRef.close();
  }

}
